(function () {
function $42c7b0aa3d520578$var$setupAnnouncementBar(announcementBar) {
    const closeButton = document.querySelector(".announcement-bar .close-btn");
    if (localStorage.getItem("announcementClosed") === "true") announcementBar.style.display = "none";
    closeButton.addEventListener("click", ()=>{
        announcementBar.style.display = "none";
        localStorage.setItem("announcementClosed", "true");
    });
}
window.addEventListener("DOMContentLoaded", ()=>{
    const announcementBar = document.querySelector(".announcement-bar");
    $42c7b0aa3d520578$var$setupAnnouncementBar(announcementBar);
}); // if (announcementBar) {
 // } else {
 // 	const announcementInterval = setInterval(() => {
 // 		announcementBar = document.querySelector(".announcement-bar");
 // 		if (announcementBar) {
 // 			clearInterval(announcementInterval);
 // 			setupAnnouncementBar(announcementBar);
 // 		}
 // 	}, 64);
 // }

})();
//# sourceMappingURL=announcementBar.js.map
